import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/ph-calculator',
  component: () => import('../../routes/PhCalculator.svelte'),
  card: {
    id: 'ph-calculator',
    title: 'pH Calculator',
    description:
      'Calculate pH, [H+], [OH-], and pOH for acids, bases, weak acids, and buffers. Includes Henderson-Hasselbalch buffer equation and temperature-dependent Kw.',
    icon: 'science',
    iconBgClass: 'bg-cyan-50',
    iconTextClass: 'text-cyan-600',
    href: '/ph-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title:
      'pH Calculator – Acid, Base, Buffer pH, [H+], [OH-], Henderson-Hasselbalch',
    description:
      'Free pH calculator for chemistry. Compute pH from [H+] or [OH-], find [H+] from pH, weak acid pH via √(Ka × C), and buffer pH via Henderson-Hasselbalch pH = pKa + log([A-]/[HA]). Includes temperature-dependent Kw (0–100 °C) and pH classification (extremely acid → extremely basic).',
  },
};

export default meta;